import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-efb062f4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "join-us"
};
const _hoisted_3 = {
  class: "con"
};
const _hoisted_4 = ["innerHTML"];

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, [/*#__PURE__*/_createElementVNode("b")], -1));

const _hoisted_6 = /*#__PURE__*/_createTextVNode("加入我们");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");

  return _ctx.flag ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h2", null, _toDisplayString(_ctx.companyData.name), 1), _createElementVNode("p", {
    innerHTML: _ctx.companyData.content
  }, null, 8, _hoisted_4), _hoisted_5, _createVNode(_component_el_button, {
    onClick: _ctx.joinUs
  }, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  }, 8, ["onClick"])])])])) : _createCommentVNode("", true);
}